/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import React, {ReactNode} from 'react';
// import tableRowView from '../table-row/table-row.view';
import { ITableViewProps } from './table';

export const TableView: React.FC<ITableViewProps> = props => {
        const {rows, rowsList, tableRow} = props;
        return(
            <Module {...rowsList}>
                {rows.map((row: ReactNode, index: number) => {
                    return (
                        <Node {...tableRow} key={index}>
                            {row}
                        </Node>
                    );
                })}
            </Module>
        );
};

export default TableView;